// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Anta&family=Chelsea+Market&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y4IjA4IirnUMlPut2HHx {
  background-color: grey;
  border-radius: 10px;
  border: 2px solid red;
  padding: 2rem;
}
.y4IjA4IirnUMlPut2HHx .V1Fl5AbsTwP5wYsD0fbl .xBQyWAUEx2Sex6slnhr2 {
  font-size: 3.5vmin;
  margin-left: auto;
  margin-right: auto;
  color: yellow;
  font-family: "Chelsea Market", sans-serif;
  text-shadow: 2px 2px 1px black;
}
.y4IjA4IirnUMlPut2HHx .V1Fl5AbsTwP5wYsD0fbl .zRg7I54ZWY99Mw5EHpCZ {
  border: 2px solid black;
}
.y4IjA4IirnUMlPut2HHx .V1Fl5AbsTwP5wYsD0fbl .jglcV6ty9Vj6fm1Ewr5Y {
  width: 20vmin;
  margin-left: auto;
  margin-right: auto;
  font-size: 3.5vmin;
}`, "",{"version":3,"sources":["webpack://./src/components/FormContainer/FormContainer.module.scss"],"names":[],"mappings":"AAEA;EACI,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;AAAJ;AAGQ;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,yCAAA;EACA,8BAAA;AADZ;AAGQ;EACI,uBAAA;AADZ;AAGQ;EACI,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AADZ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Anta&family=Chelsea+Market&display=swap');\n\n.formContainer {\n    background-color: grey;\n    border-radius: 10px;\n    border: 2px solid red;\n    padding: 2rem;\n    \n    .form {\n        .label {\n            font-size: 3.5vmin;\n            margin-left: auto;\n            margin-right: auto;\n            color: yellow;\n            font-family: \"Chelsea Market\", sans-serif;\n            text-shadow: 2px 2px 1px black;\n        }\n        .input {\n            border: 2px solid black;\n        }\n        .button {\n            width: 20vmin;\n            margin-left: auto;\n            margin-right: auto;\n            font-size: 3.5vmin;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `y4IjA4IirnUMlPut2HHx`,
	"form": `V1Fl5AbsTwP5wYsD0fbl`,
	"label": `xBQyWAUEx2Sex6slnhr2`,
	"input": `zRg7I54ZWY99Mw5EHpCZ`,
	"button": `jglcV6ty9Vj6fm1Ewr5Y`
};
export default ___CSS_LOADER_EXPORT___;
